import { styled } from '@mui/material/styles';

import { borderRadius, fontSize } from '@verantos-dev/shared-ui-components/tokens';

import { Button, type ButtonProps } from '../../../Button/Button';

const StyledDataGridHeader = styled('div')<{ skipMarginBottom?: boolean }>(
  ({ skipMarginBottom, theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(4),
    backgroundColor: theme.palette.background.paper,
    borderRadius: borderRadius.md,
    marginBottom: skipMarginBottom ? 0 : theme.spacing(4),
  })
);

const DataGridHeaderLabel = styled('div')(({ theme }) => ({
  fontSize: fontSize[24],
  fontWeight: '400',
  lineHeight: 1.5,
  color: theme.palette.text.primary,
}));

const DataGridHeaderActions = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  maxWidth: '200px',

  '&.MuiButtonBase-root': {
    marginLeft: '8px',
  },
}));

export type DataGridHeaderProps = {
  id: string;
  headerLabel: string;
  actionButtons?: ButtonProps[];
  skipMarginBottom?: boolean;
};

// DataGridHeader component
export const DataGridHeader = ({
  id,
  headerLabel,
  actionButtons,
  skipMarginBottom,
}: DataGridHeaderProps) => {
  return (
    <StyledDataGridHeader data-testid={`dataGridHeader-${id}`} skipMarginBottom={skipMarginBottom}>
      <DataGridHeaderLabel>{headerLabel}</DataGridHeaderLabel>
      <DataGridHeaderActions>
        {actionButtons?.map((button) => (
          <Button key={button.id} {...button} />
        ))}
      </DataGridHeaderActions>
    </StyledDataGridHeader>
  );
};
